import { render, staticRenderFns } from "./questionSetting.vue?vue&type=template&id=daa7d442&scoped=true&"
import script from "./questionSetting.vue?vue&type=script&lang=js&"
export * from "./questionSetting.vue?vue&type=script&lang=js&"
import style0 from "./questionSetting.vue?vue&type=style&index=0&id=daa7d442&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa7d442",
  null
  
)

export default component.exports